<template>
  <el-breadcrumb separator="/">
    <el-breadcrumb-item
      v-for="(breadcrumb, index) in breadcrumbs"
      :key="index"
    >
      <Promised
        :promise="breadcrumb"
        :pending-delay="0"
      >
        <template v-slot:pending>
          <font-awesome-icon
            :icon="['fal', 'circle-notch']"
            spin
          />
        </template>

        <template v-slot="data">
          <router-link :to="data.route">
            {{ data.name }}
          </router-link>
        </template>
      </Promised>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
import { Promised } from 'vue-promised'

export default {
  components: { Promised },
  props: {
    breadcrumbs: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-breadcrumb {
    font-size: 0.75rem;
  }
</style>
